module.exports = __webpack_public_path__ + "static/img/2-17.52665b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/2-17.png
// module id = lhVT
// module chunks = 15